import { Tag } from 'lucide-react'

/**
 * Story 3.16.1 — Display read-only para settings enum (calendar_provider,
 * seller_distribution_rule, openai_default_model, etc.). Renderiza valor
 * + label legível (via `labelMap`) com ícone.
 *
 * Se `labelMap` não cobre o valor, mostra o valor cru — fallback seguro.
 */
export function EnumDisplay({
  value,
  labelMap = {},
}: {
  value: unknown
  labelMap?: Readonly<Record<string, string>>
}): React.ReactElement {
  const raw = typeof value === 'string' ? value : String(value ?? '')
  const label = labelMap[raw] ?? raw

  return (
    <div className="flex items-center gap-2 text-sm">
      <Tag className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      <span className="font-medium">{label}</span>
      {labelMap[raw] !== undefined && labelMap[raw] !== raw && (
        <code className="text-xs text-muted-foreground">{raw}</code>
      )}
    </div>
  )
}
